/**
 * Coerce an unknown API value to an array at the RTK-query ingestion boundary.
 *
 * The trap this closes (learned from the Oxbo-Z prod crash): a real backend can
 * return a present-but-non-array body — `{}`, `{field: {}}`, `{field: null}`,
 * a 200 with a partial object, an error envelope. Neither `data ?? []` (only
 * guards null/undefined) nor a truthy `if (data)` (an object is truthy) defends
 * against that; the next `.map`/`.reduce`/spread throws and white-screens the app.
 * MSW mocks never reproduce it because they always return well-formed arrays.
 *
 * Use at EVERY point where API data feeds an iteration:
 *   const rows = asArray<AfeLine>(dsQ.data?.afe_lines);
 */
export function asArray<T>(value: unknown): T[] {
  return Array.isArray(value) ? (value as T[]) : [];
}
